// extracted by mini-css-extract-plugin
export default {"codeSpace":"CodeSpace_codeSpace__P6ApA","lineNumberList":"CodeSpace_lineNumberList__S7vrZ","inputField":"CodeSpace_inputField__Extcp"};